import React, { useContext, useEffect } from 'react';
import styled from '@emotion/styled';
import Img04 from 'ui/images/top/topService_img04@2x.png';
import Img03 from 'ui/images/top/topService_img03@2x.png';
import Img02 from 'ui/images/top/topService_img02@2x.png';
import ArrowIcon from 'ui/images/icons/arrow_triangle.png';
import { buyerUserContext } from 'application/contexts/useBuyerUser';
import { PROFILE_STAGE } from 'domain/entities/BuyerUser/BuyerUser';
import { mqMin } from 'utils/responsive';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 40px auto;
    width: 100%;

    ${mqMin('NARROW')} {
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: center;
        align-items: stretch;
    }
`;

const StepCard = styled.div`
    background-color: #f8f9fb;
    border-radius: 10px;
    padding: 20px;
    width: 100%;
    max-width: 400px;
    min-width: 280px;
    box-shadow: 2px 4px 10px 4px rgba(0, 0, 0, 0.05);
    position: relative;
    text-align: center;
    margin-bottom: 20px;

    display: flex;
    flex-direction: column;
    height: 100%;

    ${mqMin('NARROW')} {
        width: calc(33.333% - 30px);
        margin-bottom: 0;
    }
`;

const StepTitle = styled.h3`
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 16px;
`;

const Description = styled.div`
    font-size: 13px;
    font-weight: 600;
    margin-bottom: 16px;
    line-height: 1.6;
    text-align: left;
    min-height: 85px;
`;

const ActionButton = styled.button`
    display: block;
    background-color: var(--main-color-blue);
    color: white;
    text-align: center;
    padding: 8px 12px;
    border-radius: 6px;
    margin: 5px 0;
    font-size: 14px;
    font-weight: 600;
    border: none;
    width: 100%;
    cursor: pointer;

    &:hover {
        opacity: 0.9;
    }
`;
const Image = styled.img`
    height: 80px;
    margin: 10px auto;
`;

const Icon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 10px;
    width: 20px;
    transform: rotate(90deg);

    ${mqMin('NARROW')} {
        transform: rotate(0deg);
    }
`;

export const StepFlow: React.FC = () => {
    const { user } = useContext(buyerUserContext);
    const not_registration_complete = user?.account_profile_stage !== PROFILE_STAGE.COMPLETE;
    const applicationLink = not_registration_complete ? '/buyer/profile/application/' : '/buyer/edit/';

    useEffect(() => {
        const hash = window.location.hash;
        if (hash) {
            const targetId = hash.replace('#', '');
            const el = document.getElementById(targetId);
            if (el) {
                el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }
    }, []);

    const steps = [
        {
            image: Img04,
            title: 'STEP 1（ご登録後）',
            description: ['企業プロフィールを完成させ', '仲介会社からのオファー率をアップしましょう！'],
            buttons: [{ label: '企業情報を入力する', link: applicationLink }],
        },
        {
            image: Img03,
            title: 'STEP2（情報掲載中）',
            description: [
                '仲介会社からオファーが届きます。チャットを開通して、面談日を設定しましょう。',
                '案件の公開・非公開は自由に設定が可能です。オファーが届かない場合は、企業情報を魅力的にしましょう。',
            ],
            buttons: [
                { label: 'オファーを見る', link: '/buyer/match/' },
                // { label: '参考の企業情報を見る', link: '/buyer/dashboard/#top-offer-sellers' },
            ],
        },
        {
            image: Img02,
            title: 'STEP3（面談終了後）',
            description: [
                '仲介会社とのやり取り（面談）が完了すると、アンケートが届きます。',
                'アンケートへのご回答をよろしくお願いいたします。',
            ],
            buttons: [{ label: 'アンケートに回答する', link: '/buyer/match/' }],
        },
    ];
    return (
        <Container>
            {steps.map((step, index) => (
                <React.Fragment key={index}>
                    <StepCard>
                        <StepTitle>{step.title}</StepTitle>
                        <Image src={step.image} alt="イラスト" />
                        <Description>
                            {step.description.map((line, idx) => (
                                <div key={idx}>{line}</div>
                            ))}
                        </Description>
                        {step.buttons.map((btn, idx) => {
                            if (btn.link.startsWith('/buyer/dashboard/#')) {
                                const anchorId = btn.link.split('#')[1];
                                return (
                                    <ActionButton
                                        key={idx}
                                        onClick={() => {
                                            const target = document.getElementById(anchorId);
                                            if (target) {
                                                target.scrollIntoView({ behavior: 'smooth', block: 'start' });
                                            }
                                        }}
                                    >
                                        {btn.label}
                                    </ActionButton>
                                );
                            } else {
                                return (
                                    <ActionButton key={idx} onClick={() => (window.location.href = btn.link)}>
                                        {btn.label}
                                    </ActionButton>
                                );
                            }
                        })}
                    </StepCard>
                    {index < steps.length - 1 && (
                        <Icon>
                            <img src={ArrowIcon} alt="矢印" />
                        </Icon>
                    )}
                </React.Fragment>
            ))}
        </Container>
    );
};
